import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { m as motion } from 'framer-motion';
import { newFontOverride } from '@polestar/component-warehouse-react/tokens/fonts/Fonts';
export const AnimatedIconWrapper = styled.div(({ textPairing = false }) => css `
    overflow: hidden;
    justify-content: center;
    width: ${textPairing ? 1 : 1.5}em;
    height: ${textPairing ? 1 : 1.5}em;
    margin: 0 -0.075em;

    display: inline-grid;
    grid-template: 1 / 1;

    > * {
      grid-area: 1 / 1;
    }
  `);
export const AnimatedIconInner = styled(motion.div) `
  height: 100%;
  line-height: 0;
`;
export const animatedIconPairingWithTextContainerStyling = css `
  height: 1em;
  transform: translateY(-1px);
`;
// The negative translateY was causing a jumping effect for spinning icons
export const animatedRotationIconPairingWithTextContainerStyling = css `
  height: 1em;

  ${newFontOverride(css `
    transform: translateY(0);
  `)}
`;
export const animatedIconContainerStyling = {
    height: '1.5em',
};
